import { MarkerProps } from "@react-google-maps/api";
import getGoogleMapMarkerIconByType from "@toolkit/Framework/Common/Utilities/googleMap/getGoogleMapMarkerIconByType";
import { TypeOfArray } from "@toolkit/Framework/Types/Common";
import { useMemo } from "react";
import { useTheme } from "styled-components";

const useGoogleMapThemableMarkers = <
    T extends Array<TypeOfArray<T> & MarkerProps & { type: Toolkit.Theme.GoogleMap.MarkerType }>,
>(
    markers: T,
    useLabel?: boolean,
) => {
    const theme = useTheme();

    return useMemo(() => {
        return markers.map(x => {
            const text = typeof x.icon === "string" ? x.icon.match(/text=(\w*)/)?.[1] : undefined;
            const result = { ...x } as TypeOfArray<T> & MarkerProps;

            if (useLabel) {
                if (text) {
                    result.label = { text };
                }
            } else {
                result.icon = {
                    url: getGoogleMapMarkerIconByType(x.type, { theme, text }, true),
                };
            }

            return result;
        });
    }, [markers]);
};

export default useGoogleMapThemableMarkers;
